<script setup>
// import
import { ref, reactive, computed, watch, onMounted, onBeforeMount, onBeforeUnmount, provide,nextTick } from 'vue'
import Widget from './Widget.vue'
import layoutData from '../../../mockupdata/layoutData.json'
import MultiSelect from 'primevue/multiselect'

import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
// import Swiper and modules styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { useNavigatorStore } from '@/store/navigator'
const navigatorStore = useNavigatorStore()
import { useUserStore } from '@/store/user'
const userStore = useUserStore()
import html2canvas from 'html2canvas'
import EmailSendModal from "@/components/common/modal/EmailSendModal.vue"

import { getLoadUsers } from '@/api/monthly'
import { useUiStore } from '@/store/ui' // UI 스토어 임포트
import { dasboardLayoutList, dasboardLayoutEdit, getFcstYearList } from '@/api/dashboard'
import {
    resolveChartComponent,
    shouldDisplayFiscalYear,
    shouldDisplayEmployeeIdGroup1,
    shouldDisplayEmployeeIdGroup2,
    getItemLegendInfo,
    // ... fullscreen 템플릿에 필요한 다른 helper 함수들 ...
} from '@/js/widgetHelpers'; 
import { router } from '@/router'
const uiStore = useUiStore()
// props
const props = defineProps({
  columns: {
    type: Number,
    default: 12,
  },
  gap: {
    type: Number,
    default: 16,
  },
  margin: {
    type: Number,
    default: 10,
  },
  fullscreenWidth :{
    type : String,
    default:null
  }
})

// data
const WIDGETS = [
  "FCST Summary",
  "Total Rev. FCST",
  "Total GM FCST",
  "Rev. FCST",
  "GM FCST",
  "Monthly Rev. & GM FCST",
  "Total Rev. & GM FCST Weekly History",
  "Pipeline Management",
  "Pipeline Status",
  "Final Balance FCST",
  "Pipeline Hygiene"
]

const WIDGETS_CD = {
  w01: "FCST Summary",
  w02: "Pipeline Management",
  w03: "Pipeline Hygiene",
  w04: "Pipeline Status",
  w05: "Total Rev. FCST",
  w06: "Total GM FCST",
  w07: "Rev. FCST",
  w08: "GM FCST",
  w09: "Monthly Rev. & GM FCST",
  w10: "Total Rev. & GM FCST Weekly History",
  w11: "Final Balance FCST",
}

const infoGrid = reactive({})
const infoGridCell = reactive({})
const emailSendModalRef = ref();
const employeeIdOptions = ref([])
const fiscalYearOptions = ref([])
const widgets = ref([])
const windowWidth = ref(window.innerWidth);

// test layout data
const layout = reactive([])
let test = 0
const selectedLayout = ref([])
const selectedEmployeeId = ref('')
const swiperInstance = ref(null)
// data - ref
const dashboard = ref(null)
const fullscreenDashboard = ref(null)
const widgetPlaceholder = ref(null)
const IS_ADMIN = ['ADMIN', 'E'].includes(userStore.user.authGrpId)

// computed
const getWidgetOptions = computed(() => {
  const WIDGETS = [
    "FCST Summary",
    "Monthly Rev. & GM FCST",
    "Total Rev. & GM FCST Weekly History",
    "Pipeline Management",
    "Pipeline Status",
    "Pipeline Hygiene"
  ]
  const switchAuth = [
    "Total Rev. FCST",
    "Total GM FCST",
    "Rev. FCST",
    "GM FCST",
  ]

  const getFCST = switchAuth.filter(title => {
    return IS_ADMIN ? title.includes('Total') : !title.includes('Total')
  })
  const result = [...getFCST, ...WIDGETS]
  if (IS_ADMIN) result.push("Final Balance FCST")
  return result
})

// // watch
// watch(() => selectedLayout.value, (newValue, oldValue) => {
//   if (newValue.length < oldValue.length) {
//     for (let i = layout.length - 1; i >= 0; i--) {
//       if (!selectedLayout.value.includes(layout[i].name)) {
//         layout.splice(i, 1);
//       }
//     }
//   } else if (newValue.length > oldValue.length) {
//     newValue.forEach(name => {
//       if (!layout.filter(item => item.name === name).length) {
//         const item = layoutData.find(item => item.name === name)
//         item.top = 0
//         item.left = 0
//         layout.push(item)
//         align(item, item.name)
//       }
//     })
//   }
//   fillEmptyUpside()
//   setHeightDashboard()
// })

// watch
watch(() => selectedLayout.value, (newValue, oldValue) => {
    if (newValue.length < oldValue.length) {
        const removedNames = oldValue.filter(name => !newValue.includes(name));
        for (let i = layout.length - 1; i >= 0; i--) {
            if (removedNames.includes(layout[i].name)) {
                layout.splice(i, 1);
            }
        }
    }
    else if (newValue.length > oldValue.length) {
        const addedNames = newValue.filter(name => !oldValue.includes(name));
        addedNames.forEach(name => {
            if (!layout.some(item => item.name === name)) {
                const itemData = layoutData.find(item => item.name === name);
                if (itemData) {
                    const newItem = { ...itemData };
                    const columns = infoGrid.columns || props.columns;
                    if (!columns) {
                        newItem.top = 0;
                        newItem.left = 0;
                    } else {
                        const { top, left } = findNextAvailablePosition(newItem, layout, columns);
                        newItem.top = top;
                        newItem.left = left;
                    }
                    layout.push(newItem);
                } 
            }
        });
    }
    fillEmptyUpside();
    setHeightDashboard();
}, { deep: true });

watch(() => selectedEmployeeId.value, (newValue) => {
  widgets.value.forEach(widget => {
    widget.selectedEmployeeId = newValue
  })
})

// lifecycle
onBeforeMount(async () => {
  const result = await dasboardLayoutList()
  const mappedResult = result.rtn.filter(item => item.use_yn === 'y')
    .map(item => {
      return {
        name: item.widgets_nm,
        cd: item.widgets_cd,
        top: parseInt(item.widgets_top),
        left: parseInt(item.widgets_left),
        width: parseInt(item.widgets_width),
        height: parseInt(item.widgets_height),
      }
    })
  const getLayoutData = mappedResult.length ? mappedResult : layoutData
  if (mappedResult.length) {
    getLayoutData.forEach((data) => {
      selectedLayout.value.push(data.name)
      layout.push(data)
    })
    return
  }
  getLayoutData.forEach((data) => {
    const whitelist = {
      default: [
        "FCST Summary",
        "Pipeline Management",
        "Pipeline Hygiene",
        "Pipeline Status",
      ],
      isAdmin: [
        "Total Rev. FCST",
        "Total GM FCST",
      ],
      isNotAdmin: [
        "Rev. FCST",
        "GM FCST",
      ]
    }
    const auth = IS_ADMIN ? 'isAdmin' : 'isNotAdmin'
    const initLayout = [...whitelist.default, ...whitelist[auth]]
    if (!initLayout.includes(data.name)) return
    selectedLayout.value.push(data.name)
    layout.push(data)
  })

})

onMounted(async () => {
  initDashboard()
  window.addEventListener('resize', initDashboard)

  // get select options
  // const result = await getLoadUsers({
  //   employee_id: userStore.user.employeeId,
  //   auth_grp_id: userStore.user.authGrpId,
  // })
  // let fetchedOptions = result.rtn
  // if (IS_ADMIN) {
  //   fetchedOptions = [{ text: '전체', value: '' }, ...fetchedOptions]
  // }
  // employeeIdOptions.value = fetchedOptions.map(item => {
  //   if (item.text === '전체') return item
  //   return {
  //     text: `${item.user_nm}`,
  //     value: item.employee_id
  //   }
  // })
  // widgets.value.forEach(widget => {
  //   widget.selectedEmployeeId = employeeIdOptions.value.at(0).value
  // })
  employeeIdOptions.value = userStore.dashboardOptions
  await FcstYearList();
  if (!navigatorStore.isMobile) {
    setTimeout(() => {
      setHeightDashboard()
    }, 300)
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', initDashboard)
})

function initDashboard() {
  if (navigatorStore.isMobile) {
    new Swiper('.swiper', {
      // Optional parameters
      modules: [Navigation],
      direction: 'horizontal',
      loop: false,

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
        return
  }
  initInfo();
  fillEmptyUpside();
  setHeightDashboard();
  windowWidth.value = window.innerWidth;
}

watch(() => uiStore.isGlobalFullscreen, (newValue) => {
  if(!uiStore.isGlobalFullscreen){
     nextTick(() => {
      initDashboard()
    })
  }
  if (newValue && !swiperInstance.value) {
    nextTick(() => {
      swiperInstance.value = new Swiper('.swiper', {
        modules: [Navigation],
        direction: 'horizontal',
        initialSlide: uiStore.activeSlideIndex,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  } else if (!newValue && swiperInstance.value) {
    nextTick(() => {
      swiperInstance.value.destroy();
      swiperInstance.value = null;
      setHeightDashboard()
      uiStore.fullscreenLayout.forEach((layoutGrid)=>{
        getCoordsFromGridArea(layoutGrid)
      })
      initDashboard()
    })
   
  }
})
function findNextAvailablePosition(newItem, existingLayout, columns) {
    let foundPosition = false;
    let tryTop = 0;
    let maxCheckedTop = 0;
    if (existingLayout.length > 0) {
        maxCheckedTop = Math.max(0, ...existingLayout.map(item => item.top + item.height));
    }

    while (!foundPosition) {
        for (let tryLeft = 0; tryLeft <= columns - newItem.width; tryLeft++) {
            const candidateArea = {
                top: tryTop,
                left: tryLeft,
                width: newItem.width,
                height: newItem.height,
                right: tryLeft + newItem.width,
                bottom: tryTop + newItem.height,
            };
            let collision = false;
            for (const existingItem of existingLayout) {
                const existingArea = {
                    top: existingItem.top,
                    left: existingItem.left,
                    width: existingItem.width,
                    height: existingItem.height,
                    right: existingItem.left + existingItem.width,
                    bottom: existingItem.top + existingItem.height,
                };
                if (
                    candidateArea.left < existingArea.right &&
                    candidateArea.right > existingArea.left &&
                    candidateArea.top < existingArea.bottom &&
                    candidateArea.bottom > existingArea.top
                ) {
                    collision = true;
                    break;
                }
            }
            if (!collision) {
                return { top: tryTop, left: tryLeft };
            }
        } 
        tryTop++;
        if (tryTop > maxCheckedTop + (newItem.height * 5) && existingLayout.length > 0) {
             return { top: maxCheckedTop, left: 0 };
        }
        if (tryTop > 200) { 
             return { top: maxCheckedTop, left: 0 };
        }

    } 
    return { top: 0, left: 0 };
}

const FcstYearList  = async() =>{
  try {
    // setIsLoading(true)

    const res = await getFcstYearList({
      employee_id : IS_ADMIN ? '' : userStore.user.employeeId
    })
    fiscalYearOptions.value = res.rtn
  } catch (err) {
    console.error(err);
  } finally {
    // setIsLoading(false)
  }
}


// methods
function setHeightDashboard(value = 0) {
  if(!navigatorStore.isMobile){
    if(!uiStore.isGlobalFullscreen){
      const minHeight = Math.max(...layout.map(item => {
        return item.top + item.height
      }))
      infoGrid.rows = value > minHeight ? 6 : minHeight
      dashboard.value.style.height = `${(infoGridCell.height * infoGrid.rows) + (infoGrid.gap * (infoGrid.rows - 1))}px`
      infoGrid.height = dashboard.value.getBoundingClientRect().height
    }
   
  }
  
}

/**
 * init infomation (grid, gridCell)
 */
function initInfo() {

  if(uiStore.isGlobalFullscreen){
    const { width, top, left } = fullscreenDashboard.value[uiStore.activeSlideIndex].getBoundingClientRect()
    infoGrid.width = width
    infoGrid.top = top
    infoGrid.left = left
    infoGrid.columns = props.columns
    infoGrid.gap = props.gap
    infoGrid.gutters = props.columns - 1


    infoGridCell.width = (infoGrid.width - (infoGrid.gutters * infoGrid.gap)) / infoGrid.columns
    infoGridCell.height = infoGridCell.width / 2
  }else{
    const { width, top, left } = dashboard.value.getBoundingClientRect()
    infoGrid.width = width
    infoGrid.top = top
    infoGrid.left = left
    infoGrid.columns = props.columns
    infoGrid.gap = props.gap
    infoGrid.gutters = props.columns - 1


    infoGridCell.width = (infoGrid.width - (infoGrid.gutters * infoGrid.gap)) / infoGrid.columns
    infoGridCell.height = infoGridCell.width / 2
  }
}

/**
 * grid area -> coords
 * @param {object} gridArea
 * @param {number} gridArea.top
 * @param {number} gridArea.left
 * @param {number} gridArea.width
 * @param {number} gridArea.height
 */
function getCoordsFromGridArea(gridArea) {
  const clientRect = {
    top: gridArea.top * (infoGridCell.height + infoGrid.gap),
    left: gridArea.left * (infoGridCell.width + infoGrid.gap),
    width: gridArea.width * (infoGridCell.width + infoGrid.gap) - infoGrid.gap,
    height: gridArea.height * (infoGridCell.height + infoGrid.gap) - infoGrid.gap,
  }
  clientRect.right = clientRect.left + clientRect.width
  clientRect.bottom = clientRect.top + clientRect.height
  return clientRect
}

/**
 * move, resize target coord -> grid area
 * @param {HTMLElement} target 
 * @param {number} top 
 * @param {number} left 
 */
function getGridAreaFromTarget(target, top, left, includeRawValue = false) {
  const { top: t, left: l, width: w, height: h } = target.getBoundingClientRect()
  const result = {
    top: getGridTrackFromCoord('top', t - top),
    left: getGridTrackFromCoord('left', l - left),
    width: getGridTrackFromCoord('width', w),
    height: getGridTrackFromCoord('height', h),
  }
  result.right = result.left + result.width
  result.bottom = result.top + result.height
  if (includeRawValue) {
    result.raw = {
      top: getGridTrackFromCoord('top', t - top, false),
      left: getGridTrackFromCoord('left', l - left, false),
      width: getGridTrackFromCoord('width', w, false),
      height: getGridTrackFromCoord('height', h, false),
    }
    result.raw.right = result.raw.left + result.raw.width
    result.raw.bottom = result.raw.top + result.raw.height
  }
  return result
}

/**
 * coord -> grid track
 * @param {string} type - ['top', 'left', 'width', 'height'] 
 * @param {number} value - without 'px'
 * @returns {number} coord
 */
function getGridTrackFromCoord(type, value, isRound = true) {
  switch (type) {
    case 'width':
    case 'height': {
      const result = (value + infoGrid.gap) / (infoGridCell[type] + infoGrid.gap)
      return isRound ? Math.round(result) : result

    }
    case 'top':
    case 'left': {
      const propName = type === 'top' ? 'height' : 'width'
      const result = (value / (infoGridCell[propName] + infoGrid.gap))
      return isRound ? Math.round(result) : result
    }
    default:
      throw new Error('invalid type')
  }
}

/**
 * grid track -> coord
 * @param {string} type - ['top', 'left', 'width', 'height'] 
 * @param {number} value - without 'px'
 * @returns {number} grid track
 */
function getCoordFromGridTrack(type, value) {
  switch (type) {
    case 'width':
    case 'height': {
      return value * (infoGridCell[type] + infoGrid.gap) - infoGrid.gap
    }
    case 'top':
    case 'left': {
      const propName = type === 'top' ? 'height' : 'width'
      return value * (infoGridCell[propName] + infoGrid.gap)
    }
    default:
      throw new Error('invalid type')
  }
}

/**
 * move, resize event placeholder
 * @param {object} data - CSS Property: value
 */
function setStylePlaceholder(data) {
  const { style } = widgetPlaceholder.value
  Object.entries(data).forEach(([key, value]) => {
    style[key] = value
  })
}

/**
 * update layout data
 * @param {string} name - widget name
 * @param {object} data - layout property: value
 */
function setDataLayout(name, data) {
  const index = layout.findIndex(item => item.name === name)
  Object.entries(data).forEach(([key, value]) => {
    layout[index][key] = value
  })
}

/**
 * template literal for transform value
 * @param {number} x - x axis
 * @param {number} y - y axis
 * @param {number} z - z axis
 */
function setTransform(x = 0, y = 0, z = 0) {
  return `translate3d(${x}px, ${y}px, ${z}px)`
}

// set unit
function setUnit(value, unit = 'px') {
  return `${value}${unit}`
}

function collisionDetector(target, item, offset = 0) {
  const conditionCollision = {
    top: target.top + target.height > item.top + offset,
    right: item.left + item.width - offset > target.left,
    bottom: item.top + item.height - offset > target.top,
    left: target.left + target.width > item.left + offset,
  }
  return Object.values(conditionCollision).every(value => value)
}

function getCollisionRange(target, item) {
  const collisionRange = {
    top: (Math.abs(item.top - target.bottom) >= item.height ? 0 : Math.abs(item.top - target.bottom)),
    right: Math.abs((item.left + item.width) - target.left) >= item.width ? 0 : Math.abs((item.left + item.width) - target.left),
    bottom: Math.abs((item.top + item.height) - target.top) >= item.height ? 0 : Math.abs((item.top + item.height) - target.top),
    left: Math.abs(item.left - target.right) >= item.width ? 0 : Math.abs(item.left - target.right),
  }
  return Object.keys(collisionRange).filter(key => collisionRange[key])
}

function align(target, widgetName) {
  const name = target.name || widgetName
  layout.forEach(item => {
    if (name === item.name) return
    if (collisionDetector(target, item)) {
      item.top = target.top + target.height
      align(item, widgetName)
    }
  })
}

// 윗쪽 빈공간 check
function checkEmptyUpside(targetName) {
  const findTarget = item => item.name === targetName
  const target = layout.find(findTarget)

  const sizeTarget = {
    top: target.top,
    right: target.left + target.width,
    bottom: target.top + target.height,
    left: target.left,
  }
  const collision = layout.filter(item => target.name !== item.name)
    .filter(item => {
      const sizeItem = {
        top: item.top,
        right: item.left + item.width,
        bottom: item.top + item.height,
        left: item.left,
      }
      const condition = {
        top: sizeTarget.top >= sizeItem.bottom,
        left: (sizeItem.left < sizeTarget.right && sizeTarget.right <= sizeItem.right) || (sizeTarget.left < sizeItem.right && sizeItem.right <= sizeTarget.right),
        right: (sizeItem.right > sizeTarget.left && sizeTarget.left >= sizeItem.left) || (sizeTarget.right > sizeItem.left && sizeItem.left >= sizeTarget.left),
        width: target.width > item.width
      }
      return condition.top && (condition.left || condition.right)
    })
  return collision
}

// 빈공간 채우기
function fillEmptyUpside() {
  layout.forEach(item => {
    const collision = checkEmptyUpside(item.name)
    if (!collision.length) {
      item.top = 0
      return
    }
    const lastBottom = Math.max(...collision.map(item => item.top + item.height))
    if (item.top === lastBottom) return
    if (item.top > lastBottom) {
      item.top = lastBottom
      fillEmptyUpside()
    }
  })
}

// move outside detector
function moveOutsideDetector(parsedData, offsetRight, target) {
  const conditionOutside = {
    top: parsedData.top < 0,
    right: target.right > infoGrid.columns,
    left: parsedData.left < 0,
  }

  if (conditionOutside.top && conditionOutside.left) {
    return [0, 0]
  }

  if (conditionOutside.top && conditionOutside.right) {
    return [getCoordFromGridTrack('left', infoGrid.columns - target.width), 0]
  }

  if (conditionOutside.left) {
    return [0, parsedData.top]
  }

  if (conditionOutside.right) {
    return [getCoordFromGridTrack('left', infoGrid.columns - target.width), parsedData.top]
  }

  if (conditionOutside.top) {
    return [parsedData.left, 0]
  }



  return [parsedData.left, parsedData.top]
}


// move event handler
function moveHandler({ target: widget, $event: mousedown, name }) {
  widget.classList.add('dragging')

  const offset = dashboard.value.getBoundingClientRect()
  const mousedownWidget = widget.getBoundingClientRect()

  const shiftX = mousedown.pageX - mousedownWidget.left
  const shiftY = mousedown.pageY - mousedownWidget.top

  setTimeout(() => {
    widgetPlaceholder.value.classList.add('active')
  })

  setStylePlaceholder({
    transform: setTransform(mousedown.pageX - shiftX - offset.left, mousedown.pageY - shiftY - offset.top),
    width: setUnit(mousedownWidget.width),
    height: setUnit(mousedownWidget.height)
  })

  function move(x, y) {
    widget.style.transform = setTransform(x - shiftX - offset.left, y - shiftY - offset.top)

    const targetGridAreaData = getGridAreaFromTarget(widget, offset.top, offset.left, true)
    const parsedData = getCoordsFromGridArea(targetGridAreaData)
    setHeightDashboard(targetGridAreaData.top + targetGridAreaData.height)

    setStylePlaceholder({ transform: setTransform(...moveOutsideDetector(parsedData, offset.right, targetGridAreaData)) })
    const placeholderGridAreaData = getGridAreaFromTarget(widgetPlaceholder.value, offset.top, offset.left)

    align(placeholderGridAreaData, name)
  }

  function mousemoveHandler(mousemove) {
    move(mousemove.pageX, mousemove.pageY)
  }

  window.addEventListener('mousemove', mousemoveHandler)
  window.onmouseup = (mouseup) => {
    const { top, left } = widgetPlaceholder.value.getBoundingClientRect()
    widget.classList.remove('dragging')
    widgetPlaceholder.value.classList.remove('active')

    setDataLayout(name, {
      top: getGridTrackFromCoord('top', 0),
      left: getGridTrackFromCoord('left', 0)
    })
    setDataLayout(name, {
      top: getGridTrackFromCoord('top', top - offset.top),
      left: getGridTrackFromCoord('left', left - offset.left)
    })
    const target = getGridAreaFromTarget(widgets.value.find(widget => widget.name === name).element, offset.top, offset.left)
    align(target, name)
    fillEmptyUpside()
    setHeightDashboard()

    window.removeEventListener('mousemove', mousemoveHandler)
    window.onmouseup = null
  }
}

// resize event handler
function resizeHandler({ target: widget, $event: mousedown, name }) {
  mousedown.stopPropagation()
  widget.classList.add('resizing')

  const offset = dashboard.value.getBoundingClientRect()
  const mousedownWidget = widget.getBoundingClientRect()

  const shiftX = mousedown.pageX - mousedownWidget.width
  const shiftY = mousedown.pageY - mousedownWidget.height

  const transshiftX = mousedown.pageX - mousedownWidget.left
  const transshiftY = mousedown.pageY - mousedownWidget.top

  setTimeout(() => {
    widgetPlaceholder.value.classList.add('active')
  })

  setStylePlaceholder({
    transform: setTransform(mousedown.pageX - transshiftX - offset.left, mousedown.pageY - transshiftY - offset.top),
    width: setUnit(mousedownWidget.width),
    height: setUnit(mousedownWidget.height)
  })

  function resize(x, y) {
    widget.style.height = setUnit(y - shiftY)
    widget.style.width = setUnit(x - shiftX)

    const toCoordData = getGridAreaFromTarget(widget, offset.top, offset.left)
    const parsedData = getCoordsFromGridArea(toCoordData)

    const stylePlaceholder = {
      width: setUnit(parsedData.right > offset.right ? getCoordFromGridTrack('width', infoGrid.columns - toCoordData.left) : parsedData.width),
      height: setUnit(parsedData.height)
    }
    if (toCoordData.width < 4) {
      stylePlaceholder.width = getCoordFromGridTrack('width', 4)
    }
    if (toCoordData.width + toCoordData.left > 12) {
      stylePlaceholder.width = getCoordFromGridTrack('width', 12 - toCoordData.left)
    }
    if (toCoordData.height < 6) {
      stylePlaceholder.height = getCoordFromGridTrack('height', 6)
    }
    setStylePlaceholder(stylePlaceholder)

    const placeholderGridAreaData = getGridAreaFromTarget(widgetPlaceholder.value, offset.top, offset.left)

    align(placeholderGridAreaData, name)

  }
  function resizeHandler(mousemove) {
    resize(mousemove.pageX, mousemove.pageY)
  }

  window.addEventListener('mousemove', resizeHandler)

  window.onmouseup = (mouseup) => {
    const { width, height } = widgetPlaceholder.value.getBoundingClientRect()
    widget.classList.remove('resizing')
    widgetPlaceholder.value.classList.remove('active')

    setDataLayout(name, {
      width: getGridTrackFromCoord('width', 0),
      height: getGridTrackFromCoord('height', 0)
    })
    setDataLayout(name, {
      width: getGridTrackFromCoord('width', width),
      height: getGridTrackFromCoord('height', height)
    })
    const target = getGridAreaFromTarget(widgets.value.find(widget => widget.name === name).element, offset.top, offset.left)
    align(target, name)
    fillEmptyUpside()
    setHeightDashboard()

    window.removeEventListener('mousemove', resizeHandler)
    window.onmouseup = null
  }
}

// save layout
async function updateLayoutData() {
  if (!confirm('현재 상태를 저장하시겠습니까?')) {
    return alert('취소되었습니다.')
  }
  const currLayoutData = Object.keys(WIDGETS_CD)
    .filter(cd => getWidgetOptions.value.includes(WIDGETS_CD[cd]))
    .map(cd => {
      if (!selectedLayout.value.includes(WIDGETS_CD[cd])) {
        return {
          widgets_cd: cd,
          widgets_top: 0,
          widgets_left: 0,
          widgets_width: 0,
          widgets_height: 0,
          use_yn: 'n'
        }
      }
      const currLayout = layout.find(item => item.name === WIDGETS_CD[cd])
      return {
        widgets_cd: cd,
        widgets_top: currLayout.top,
        widgets_left: currLayout.left,
        widgets_width: currLayout.width,
        widgets_height: currLayout.height,
        use_yn: 'y'
      }
    })
  await dasboardLayoutEdit(currLayoutData)
  alert('저장되었습니다.')
}

/** 메일발송 모달 (3.팝업오픈) */
async function openEmailSend(title, { img, employeeId, legend ,base64Data}) {
  const additionalInfoWhiteList = [
    "Total Rev. FCST",
    "Pipeline Status",
    "Total Rev. & GM FCST Weekly History",
    "Monthly Rev. & GM FCST",
    "FCST Summary",
    "Total GM FCST",
    "Pipeline Management",
    "Pipeline Hygiene"
  ]
  function getContent() {
    const hasInfo = additionalInfoWhiteList.includes(title)
    const contentTitle = `<h1 style="text-align: center;">${title}${hasInfo && employeeId ? `-${employeeId}` : ''}${hasInfo && legend ? `-${legend}` : ''}</h1>`
    return `
      ${contentTitle}<br />
      <p style="text-align: center;">${img}</p>
    `
  }
  const emailParams = {
    call_prgm_id: 'MRD_DS_002',
    call_prgm_nm: '대시보드',
    receiver_ids: '',
    receiver_nms: '',
    title: `대시보드 ${title} 정보 공유드립니다.`,
    content: getContent(),
  };
  emailSendModalRef.value.openEmailModal(emailParams);
};
provide('allLayoutData', layout);

const fullscreenWidth = computed(() => {
  return  windowWidth.value / 100 * 50 || 0
})

const linkReport = ((name) => {
  const links = {
    'FCST Summary': "/rd/MRD_RT_001",
    'Pipeline Management': "/rd/MRD_RT_001",
    'Final Balance FCST': "/rd/MRD_RT_002",
    'Pipeline Hygiene': "/rd/MRD_RT_004",
    'Total Rev. FCST': "/rd/MRD_RT_001",
    'Total GM FCST': "/rd/MRD_RT_001",
    'Rev. FCST': "/rd/MRD_RT_001",
    'GM FCST': "/rd/MRD_RT_001",
    'Monthly Rev. & GM FCST': "/rd/MRD_RT_003",
    'Pipeline Status': "/rd/MRD_RT_001",
  }
  
  return links[name]
})

const handleLinkClick = ((name) => {
  uiStore.exitFullscreen()
  router.push(linkReport(name))
})
</script>

<template>
  <div v-if="!uiStore.isGlobalFullscreen">
  <div v-if="!navigatorStore.isMobile" class="d-flex align-items-center column-gap-3">
    <ElSelect v-if="userStore.user?.authGrpId !== 'C'" :class="[IS_ADMIN ? 'ml-auto' : '']" v-model="selectedEmployeeId"
      :options="employeeIdOptions" />
    <ElButton :class="[!IS_ADMIN ? 'ml-auto' : '']" type="primary" @buttonClick="updateLayoutData">저장</ElButton>
    <MultiSelect v-model="selectedLayout" :options="getWidgetOptions" placeholder="Select Widget" :maxSelectedLabels="3"
      class="w-30rem">
    </MultiSelect>
  </div>
  <div v-if="!navigatorStore.isMobile" class="dashboard-wrapper" :style="{ padding: `${margin}px` }">
    <div ref="dashboard" class="dashboard">
      <Widget v-for="item in layout" ref="widgets" :key="item" :name="item.name" :gridArea="item"
        :clientRect="getCoordsFromGridArea(item)" :data="item.data" :employeeIdOptions="employeeIdOptions" :fiscalYearOptions="fiscalYearOptions"
        @move="moveHandler" @resize="resizeHandler" @captureWidget="openEmailSend" />
      <div ref="widgetPlaceholder" class="widget-placeholder"></div>
    </div>
    
  </div>
  <div class="swiper" v-else>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slides -->
      <div class="swiper-slide" v-for="item in layout">
        <Widget ref="widgets" :key="item" :name="item.name" :employeeIdOptions="employeeIdOptions"  :fiscalYearOptions="fiscalYearOptions"
          :clientRect="getCoordsFromGridArea(item)" :data="item.data" />
      </div>
        

    </div>
  <!-- If we need navigation buttons -->
  <!-- <div class="swiper-button-prev"></div>
  <div class="swiper-button-next"></div> -->
    <!-- If we need scrollbar -->
    <!-- <div class="swiper-scrollbar"></div> -->
  </div>
</div>

  <teleport to="body" v-if="uiStore.isGlobalFullscreen">
  <!-- Swiper 컨테이너 (ref는 부모 <script setup>에서 선언) -->
  <div class="swiper fullscreen-swiper"  ref="fullscreenWidget" id="fullscreen-widget">
    <!-- Swiper Wrapper -->
    <div class="swiper-wrapper">
      <!-- Swiper Slides (스토어의 fullscreenLayout 데이터 사용) -->
      <div class="swiper-slide" v-for="item in uiStore.fullscreenLayout" :key="item.cd || item.name">
        <!-- 각 슬라이드의 내용 -->
        <div class="fullscreen-slide-content" id="fullscreen-widget">
          <div class="btn-wrap" style="display: flex; align-items: center; justify-content: flex-end; position: relative; margin-right: 30px; gap: 25px;">
            <div class="radio-btn-toggle" style="display: flex; gap: 5px;">
              <template v-if="item.showChartTypeSelector">
                <template v-for="(type, index) in item.chartTypeOptions" :key="`${type}${item.name}`">
                  <input v-model="item.selectedChartType" :value="type" :id="`${type}${item.name}-full`" type="radio" class="btn-check" style="display: none;">
                  <label :for="`${type}${item.name}-full`" class="btn btn-sm px-2">
                    <i :class="[
                      'fa-solid',
                      `fa-chart-${{ bar: 'column', line: 'line', doughnut: 'pie', vertical: 'simple', horizontal: 'simple' }[type]}`,
                      type === 'horizontal' ? 'horizontal' : ''
                    ]"></i>
                  </label>
                </template>
              </template>
            </div>
            <button type="button" class="btn btn-close" style="flex-grow: 1;" @click="uiStore.exitFullscreen()" aria-label="닫기"></button>
          </div>
          <!-- 제목 (item 데이터 사용) -->
          <div class="title2">{{ item.name }}</div>

          <!-- 옵션 영역 (item 데이터 및 Helper 함수 사용) -->
          <div class="options3" :style="{ width: fullscreenWidth + 'px'}">
            <ElSelect
              v-if="shouldDisplayFiscalYear(item.name)"
              v-model="item.selectedFiscalYear"
              :options="fiscalYearOptions" 
              placeholder="회계연도"
              style="min-width: 100px;" />

            <ElSelect
              v-if="shouldDisplayEmployeeIdGroup1(item.name, userStore.isAdmin)"
              v-model="item.selectedEmployeeId"
              :options="employeeIdOptions" 
              placeholder="직원"
              style="min-width: 120px;" />

            <template v-if="getItemLegendInfo(item.name).isShow">
              <div v-if="!navigatorStore.isMobile && getItemLegendInfo(item.name).options.length < 4" class="radio-btn-toggle">
                <ElLabel v-for="legendOpt in getItemLegendInfo(item.name).options" :key="legendOpt.value" :name="legendOpt.text" classNm="btn btn-sm">
                  <template #start="{ id }">
                    <ElRadio
                      v-model="item.selectedLegend"
                      :value="legendOpt.value"
                      class="btn-check"
                      :id="id"
                      :name="`${item.name}-legend`" />
                  </template>
                </ElLabel>
              </div>
              <ElSelect
                v-else
                v-model="item.selectedLegend"
                :options="getItemLegendInfo(item.name).options"
                placeholder="범례"
                style="min-width: 120px;" />
            </template>

            <ElSelect
              v-if="shouldDisplayEmployeeIdGroup2(item.name, userStore.isAdmin)"
              v-model="item.selectedEmployeeId"
              :options="employeeIdOptions" 
              placeholder="직원"
              style="min-width: 120px;" />
          </div>
          <div class="fullscreen-content" ref="fullscreenDashboard">
            <component
              :key="item.cd || item.name" 
              :is='resolveChartComponent(item.name)'
              :gridArea="item" 
              :employeeId="item.selectedEmployeeId"
              :legend="item.selectedLegend"
              :chartType="item.selectedChartType"
              :width="fullscreenWidth"
              :height="fullscreenWidth/2" 
              :fiscalYear="item.selectedFiscalYear"
              :title="`${item.name}-full`"
              v-if="resolveChartComponent(item.name)"
            />
            <div class="widget-bottom" data-html2canvas-ignore>
              <div draggable="false" v-if="linkReport(item.name)"  @click="handleLinkClick(item.name)" class="link-report">Link Report</div>
            </div>
          </div>
        </div>   
      </div>
    </div>


    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</teleport>
  <!-- 메일발송 모달 (1.컴포넌트) -->
  <EmailSendModal ref="emailSendModalRef" />
</template>

<style scoped>
.dashboard-wrapper {
  margin-top: 1rem;
  border: 1px solid #b7c1db;
  border-radius: 0.5rem;
}

.dashboard {
  position: relative;
}

.widget-placeholder {
  position: absolute;
  display: none;
  width: 100px;
  height: 100px;
  background-color: rgba(102, 46, 207, 0.1);
  box-sizing: border-box;
  border-radius: 0.5rem;
  border: 1px solid rgba(255, 0, 0, .4);
  transition: none;
  z-index: 0;
}

.widget-placeholder.active {
  display: block;
  transition: all .3s;
}


.swiper-button-prev,
.swiper-button-next {
  color: black; /* 화살표 색상 */
  font-size: 20px; /* 화살표 크기 */
  top: 50%;
  width: calc(var(--swiper-navigation-size)/ 44 * 27);
  height: var(--swiper-navigation-size);
  margin-top: calc(0px - (var(--swiper-navigation-size)/ 2));
  z-index: 99;
  cursor: pointer;
  display: flex;
  align-items: center;
  /* justify-content: center; */
}

.widget {
  position: absolute;
  display: flex;
  flex-direction: column;
  row-gap: .5rem;
  user-select: none;
  transition: all .2s;
  z-index: 1;
  border: 1px solid #b7c1db;
  border-radius: 0.5rem;
  background-color: #fff;
  overflow: hidden;
}

.widget .title {
  font-weight: 700;
  text-align: center;
}

.title2 {
  font-weight: 700;
  text-align: center;
  font-size: 4rem;
}

.widget.dragging {
  transition: none;
  z-index: 1000;
}

.widget.resizing {
  transition: none;
  opacity: .5;
  z-index: 1000;
}

.btn-wrap {
  display: flex;
}

.widget-bottom {
 position: fixed; /* 화면을 기준으로 위치 고정 */
  right: 0;        /* 오른쪽 끝에 배치 */
  bottom: 0;       /* 아래쪽 끝에 배치 */
  display: flex;
  margin: 20px; /* 기존 margin은 유지하거나 필요에 따라 조정 */
  margin-top: auto; /* 필요 없을 수 있음 */
  z-index: 1000;   /* 다른 요소 위에 표시되도록 z-index 값 설정 (선택 사항) */
}

.widget-bottom .link-report {
  margin-left: auto;
  margin-top: -7px;
}
.widget-bottom .link-report2 {
  margin-left: auto;
}
.link-report:hover { /* 마우스 호버 시 스타일을 적용할 텍스트 요소의 CSS 선택자 */
  text-decoration: underline;
  cursor: pointer;
}

.btn-resize {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background: url(data:image/svg+xml;base64,PHN2ZyBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjYiIGhlaWdodD0iNiI+PHBhdGggZD0iTTYgNkgwVjQuMmg0LjJWMEg2djZ6IiBvcGFjaXR5PSIuMzAyIi8+PC9zdmc+);
  background-position: 100% 100%;
  padding: 0 3px 3px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: se-resize;
  z-index: 1;
}

.radio-wrap {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.options {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
}
.options2 {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
  margin-top : -7px;
}
.options3 {
  display: flex;
  justify-content: space-between; /* 주축(가로) 방향 가운데 정렬 */
  align-items: center;    /* 교차축(세로) 방향 가운데 정렬 (필요한 경우) */
  width: var(--fullscreenWidth);
  padding: 7px 1rem; /* 위쪽 패딩 추가 */
}

#fullscreen-widget {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2rem;
  background-color: #fff;
  z-index: 9999;
}

#fullscreen-widget .btn-wrap {
  align-items: center;
  margin-left: auto;
}

.fullscreen-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 70vh;
}

.radio-btn-toggle {
  background-color: #fff;
}

.btn-check:checked+.btn {
  background: none;
  background-color: #e5eaef;
}

.move {
  cursor: move;
}

.fa-chart-simple.horizontal {
  rotate: 90deg;
}
</style>